interface FilterResult {
	condition: string,
	field: string,
	id: string,
	multi: string,
	type: string,
	value: any,
	values: any,
}

interface FilterResultCompatible {
	/*是否为自定义逻辑表达式*/
	isDiyLogic: boolean,
	isLogicConfig: boolean,
	/*
	*  自定义逻辑表达式（原始的，该表达式中的id对应的是 filterResults中的id）
	*  filterOperator 是基于 logicOperator表达式生成的。filterOperator中的id对应的是 filtersRaw 中的id
	*/
	logicOperator: string,
}

/**
 * 解析filterResults
 * filterResults是一个数组。
 * @author  韦胜健
 * @date    2021/3/18 9:15
 */
export function decodeFilterResults(filterResults?: (FilterResult | FilterResultCompatible)[]): {
	/*排除 FilterResultCompatible 之后的，纯粹的 FilterResults数组*/
	results: FilterResult[],
	/*FilterResultCompatible 对象，旧的数据可能没有*/
	compatible?: FilterResultCompatible,
	/*是否含有 compatible 对象*/
	isCompatible: boolean,
} {
	if (!filterResults || filterResults.length === 0) {return {results: [], isCompatible: false}}
	filterResults = [...filterResults]
	const last = filterResults.pop()!
	if ('isDiyLogic' in last && 'isLogicConfig' in last && 'logicOperator' in last) {
		return {
			results: filterResults as FilterResult[],
			compatible: last,
			isCompatible: last.isDiyLogic,
		}
	} else {
		return {results: [...filterResults, last] as FilterResult[], isCompatible: false}
	}
}